import axios from 'src/utils/axios';
import { getLabours, getMaterials } from './afterSalesDataServices';

const transportPromiseCache = {};

export const getWorkOrderTransport = (job, serviceShopId, refreshVatPrices = false) => {
  const url = `/GetSiriusTransport/${serviceShopId}/${job.WarrantyTypeId}/0/${job.ReceiptNo}`;
  if (refreshVatPrices) delete transportPromiseCache[url];
  if (!transportPromiseCache[url]) {
    transportPromiseCache[url] = axios.get(url).catch(error => {
      delete transportPromiseCache[url];
      throw error;
    });
  }
  return transportPromiseCache[url];
};

// Publish nothing until every VAT-dependent source has been refreshed.
export async function changeWorkOrderVat(job, vatId, serviceShopId) {
  const result = await axios.post(`/SetWorkOrderVat/${job.ReceiptNo}/${vatId}`);
  if (result.data === false || result.data?.IsSuccess === false) {
    throw new Error('VAT update failed');
  }
  const params = {
    kulModelKodu: job.ModelCode,
    garantiTipi: job.WarrantyTypeId,
    hizmetKodu: 1,
    uyil: job.ProductionYear || 0,
    udonem: job.ProductionMonth || 0,
    WorkOrderId: job.ReceiptNo,
    WorkOrderIdParam: job.ReceiptNo
  };
  const [labours, materials, transport, workOrders] = await Promise.all([
    getLabours({ ...params, refreshVatPrices: true }),
    getMaterials(params),
    getWorkOrderTransport(job, serviceShopId, true),
    axios.get(`/GetConsumerWorkOrder/${job.ReceiptNo}`)
  ]);
  const updatedJob = Array.isArray(workOrders.data)
    ? workOrders.data.find(item => String(item.ReceiptNo) === String(job.ReceiptNo))
    : undefined;
  // These catalogue endpoints also represent an empty list as an empty string.
  const labourRows = labours.data === '' ? [] : labours.data;
  const materialRows = materials.data === '' ? [] : materials.data;
  const transportRows = transport.data === '' ? [] : transport.data;
  if (!updatedJob || !Array.isArray(labourRows) ||
      !Array.isArray(materialRows) || !Array.isArray(transportRows) ||
      !Array.isArray(updatedJob.WorkOrderTransport) ||
      !Array.isArray(updatedJob.WorkOrderExtra)) {
    throw new Error('Incomplete VAT refresh');
  }
  return {
    labours: labourRows,
    materials: materialRows,
    transport: transportRows,
    job: updatedJob
  };
}
